import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import Image from 'components/Basic/Image/Image';
import { GtmListNameType } from 'types/gtm';
import { ListedProductType } from 'types/product';

export type ItemProps = {
    item: ListedProductType;
    gtmListName: GtmListNameType;
    listIndex: number;
};

export const TEST_IDENTIFIER = 'pages-category-promoted-item-';

export const Item: FC<Pick<ItemProps, 'item'>> = ({ item, children }) => {
    return (
        <div className="relative flex flex-row flex-wrap items-center border-t border-grayLighter py-4 first-of-type:border-0">
            <div className="flex w-20 items-center pr-4" data-testid={TEST_IDENTIFIER + 'image'}>
                <ExtendedNextLink
                    type="product"
                    href={item.slug}
                    className="flex h-20 w-20 items-center justify-center"
                >
                    <Image src={item.image} alt={item.fullName} width="60" height="46" />
                </ExtendedNextLink>
            </div>
            {children}
        </div>
    );
};
